import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import translate from "i18n/translate";
import { View, BankLogo } from "components/utils";
import useStyles from "./speiTransferStyles";
import SpeiTransferCard from "./SpeiTransferCard";
import SponsorsDialog from "./SponsorsDialog";
import { Typography, SrButton, SrTitle } from "../../../common";

const SpeiTransfer = () => {
  const classes = useStyles();
  const [sponsorsDialog, setSponsorsDialog] = useState(false);

  return (
    <View translateTitleKey="menu.speiTransfer">
      <SrTitle>{translate("speiTransfer.heading")}</SrTitle>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3" className={classes.subHeading}>
            {translate("speiTransfer.subHeading.primary")}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">
            {translate("speiTransfer.subHeading.secondary")}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <SpeiTransferCard />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1Tertiary">
            {translate("speiTransfer.content.p2")}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2Small">
            {translate("speiTransfer.content.p3")}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid item>
            <Typography variant="h3">
              {translate("speiTransfer.banksLogos")}
            </Typography>
            <Grid item container direction="row">
              <BankLogo bankName="citibanamex" className={classes.bankLogo} />
              <BankLogo bankName="banorte" className={classes.bankLogo} />
              <BankLogo bankName="inbursa" className={classes.bankLogo} />
              <BankLogo bankName="scotiabank" className={classes.bankLogo} />
              <BankLogo bankName="santander" className={classes.bankLogo} />
              <BankLogo bankName="hsbc" className={classes.bankLogo} />
              <BankLogo bankName="bbva" className={classes.bankLogo} />
              <BankLogo bankName="copel" className={classes.bankLogo} />
            </Grid>
            <SrButton
              variant="contained"
              color="primary"
              onClick={() => setSponsorsDialog(true)}
            >
              {translate("speiTransfer.seeFullList")}
            </SrButton>
          </Grid>
        </Grid>
      </Grid>
      <SponsorsDialog
        open={sponsorsDialog}
        handleClose={() => setSponsorsDialog(false)}
      />
    </View>
  );
};

export default SpeiTransfer;
